<template>
  <div class="login-container">
    <div class="container login-box-container">
      <div class="login-box">
        <div class="login-form">
          <div class="title-container">
            <h3 class="title">{{ provider_display_name_raw }}</h3>
            <div class="description">{{ $t('FP25-02') }}</div>
          </div>
          <div>
            <input v-model="loginForm.password" type="password" class="form-control" :class="{ 'error-input' : invalidPasswordMessage }" :placeholder="$t('FP25-03')" :aria-label="$t('FP25-03')" aria-describedby="Password" required>
            <div v-show="invalidPasswordMessage" class="error-message">
              {{ $t(invalidPasswordMessage) }}
            </div>
          </div>
          <div class="d-block mt-5 btn btn-primary submit-btn" @click="handleLogin">{{ $t('FP25-04') }}</div>
        </div>
      </div>
    </div>
    <div v-if="!loaded" class="d-flex justify-content-center loading-layer">
      <div class="spinner-border theme-spinner" role="status">
        <span class="sr-only">Loading...</span>
      </div>
    </div>
    <div
      v-if="showAlert"
      role="alert"
      :class="'alert ' + alertClass"
      data-aos="fade-down"
    >
      <i class="fas fa-times-circle" />
      <p class="el-message__content">{{ alertMessage }}</p>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { getPortalJWT } from '@/api/portal'
import { setJWTTokenInCookie } from '@/utils/set-token-in-cookie-util'

export default {
  name: 'PortalPassword',
  props: {
    redirectLink: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      loginForm: {
        password: ''
      },
      invalidPasswordMessage: '',
      loaded: true,
      showAlert: false
    }
  },
  computed: {
    ...mapGetters([
      'provider_short_id', 'provider_display_name', 'provider_display_name_raw', 'client_id'
    ])
  },
  created() {
  },
  methods: {
    validate() {
      if (!this.loginForm.password) {
        this.invalidPasswordMessage = 'err-general-02-01'
        return false
      } else {
        this.invalidPasswordMessage = ''
        return true
      }
    },
    async handleLogin() {
      const valid = this.validate()
      if (valid) {
        this.loaded = false
        await getPortalJWT(this.provider_short_id, this.provider_display_name, this.loginForm.password)
          .then(async res => {
            console.log('res', res)
            console.log('client_id', this.client_id)
            this.$store.dispatch('token/updateJWTToken', { client_id: this.client_id, token: res['data']['JWT'] })
            await setJWTTokenInCookie()
            if (this.redirectLink) {
              this.$router.push(decodeURIComponent(this.redirectLink))
            } else {
              if (this.$route.params.api_name) {
                this.$router.push(`/${this.provider_path}/api/${this.$route.params.api_name}`)
              } else {
                this.$router.push(`/${this.provider_path}`)
              }
            }
          })
          .catch(err => {
            console.log(err)
            if (err.status === 401 || err.response.data.message.toLowerCase() === 'incorrect password') {
              this.invalidPasswordMessage = 'err-general-03-01'
            } else {
              this.setAlert(this.$t('err-general-05-03'), 'error')
            }
          })
          .finally(() => {
            this.loaded = true
          })
      }
    },
    setAlert(alertMessage, alertClass) {
      if (!this.showAlert) {
        this.showAlert = true
        this.alertMessage = alertMessage
        this.alertClass = alertClass
        setTimeout(() => { this.showAlert = false }, 2000)
      }
    }
  }
}
</script>

<style lang="scss" scoped>

/* reset element-ui css */
.login-container {
  height: 100vh;
  width: 100%;
  background-color: #F7FAFF;
  padding: 24px 0px;
  position: relative;
  overflow-y: scroll;
  display: flex;
  align-items: center;

  .title-container {
    position: relative;
    text-align: center;

    .title {
      font-size: 26px;
      color: #1C344C;
      margin: 0px auto 30px auto;
      font-weight: bold;
    }

    .description {
      color: #505050;
      margin-bottom: 20px;
    }
  }
}
.login-box-container {
  max-width: 548px;
  .login-box {
    border-radius: 5px;
    padding: 48px;
    background-color: #FFFFFF;
    box-shadow: 0 12px 15px 0 rgb(140 152 164 / 10%);
  }
}
.password-input {
  width: 100%;
}
.submit-btn {
  margin-bottom: 20px;
}
.error-message {
  color: #DE4437;
  font-size: 12px;
}
.error-input {
  border-color: #DE4437;
}
.loading-layer {
  z-index: 2000;
  position: absolute;
  height: 100%;
  width: 100%;
  background: rgba(256, 256, 256, 0.5);
  .spinner-border {
    margin: auto;
  }
}
.alert {
  position: fixed;
  left: 50%;
  top: 20px;
  margin-left: -270px;
  padding: 15px;
  padding-left: 20px;
  z-index: 2000;

  width: 540px;
  border-radius: 4px;

  display: flex;
  align-items: center;

  i {
    margin-right: 10px;
  }

  p {
    color: inherit;
    font-size: 14px;
    line-height: 1;
    margin-bottom: 0px;
    padding: 0px;
  }
}

.alert.success {
  background-color: #f0f9eb;
  border: #e1f3d8 1px solid;
  color: #67c23a;
}

.alert.error {
  background-color: #ffeded;
  border: #e6ebf5 1px solid;
  color: #ff4949;
}
</style>
